module.exports = __webpack_public_path__ + "img/animation_src_3.4e989dc3.webp";